import { getEnvVar } from '@/lib/runtimeEnv'

export interface UrlHelper {
  www: (url?: string) => string
  app: (url?: string) => string
  api: (url?: string) => string
  domain: () => string
}

export const APP_URL: string = getEnvVar('VITE_APP_URL', '') ?? ''
export const API_URL: string = getEnvVar('VITE_API_URL', '') ?? ''
export const FAQ_URL =
  'https://support.jobscan.co/hc/en-us/sections/360010544614-Frequently-Asked-Questions'
export const WWW_URL: string = getEnvVar('VITE_WWW_URL', '') ?? ''
export const SITEJABBER_URL =
  'https://www.sitejabber.com/reviews/jobscan.co?rating=5'

const urlHelper: UrlHelper = {
  www: (url = '') => {
    return WWW_URL + url
  },
  app: (url = '') => {
    return APP_URL + url
  },
  api: (url = '') => {
    return API_URL + url
  },
  domain: () => {
    return window.location.hostname.split('.').slice(-2).join('.')
  },
}

export const redirect = (urlString: string): void => {
  // @ts-ignore
  window.location = new URL(urlString)
}

export const getNewTabUrl = (url: string): string => {
  if (url && !url.startsWith('http')) {
    return `http://${url}`
  }
  return url
}

export default urlHelper
